import { Component } from "react";

// Catches lazy-chunk load failures (common after a new deploy when the old page
// references chunk filenames that no longer exist) and auto-reloads once so the
// user silently gets the fresh build instead of a blank screen.
export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError(error) {
    const msg = `${error?.name || ""} ${error?.message || ""}`;
    const isChunkError = /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module/i.test(msg);
    if (isChunkError && !sessionStorage.getItem("chunk_reloaded")) {
      sessionStorage.setItem("chunk_reloaded", "1");
      window.location.reload();
      return { failed: false };
    }
    return { failed: true };
  }

  componentDidMount() {
    // clear the guard once a fresh load succeeds
    sessionStorage.removeItem("chunk_reloaded");
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-center px-4" data-testid="chunk-error">
          <p className="text-sm text-muted-foreground">Kuch load hone me dikkat aayi.</p>
          <button
            onClick={() => { sessionStorage.removeItem("chunk_reloaded"); window.location.reload(); }}
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm"
            data-testid="chunk-error-reload"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
